(() => {
  document.querySelectorAll('[data-ul-product-reviews]').forEach((root) => {
    const grid = root.querySelector('[data-review-grid]');
    const status = root.querySelector('[data-review-status]');
    let page = 1;
    let total = 0;
    let autoplay;
    let loading = false;

    const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
    const stars = (rating) => '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(rating);
    const date = (value) => new Intl.DateTimeFormat('es-MX', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(value));
    const author = (value) => {
      const name = String(value || '').trim();
      return /\S+@\S+\.\S+/.test(name) ? 'Cliente verificado' : (name || 'Cliente');
    };
    const card = (review) => {
      const article = document.createElement('article');
      article.className = `ul-product-reviews__card${review.media?.length ? ' has-media' : ''}`;
      if (review.media?.length) {
        article.tabIndex = 0;
        article.setAttribute('role', 'button');
        article.setAttribute('aria-expanded', 'false');
        article.setAttribute('aria-label', 'Ver texto de la reseña');
      }
      const media = review.media?.[0] ? `<img src="${esc(review.media[0])}" alt="Foto compartida en la reseña" loading="lazy">` : '';
      article.innerHTML = `${media}<div class="ul-product-reviews__card-body"><div class="ul-product-reviews__card-top"><span>${stars(Number(review.rating) || 0)}</span><time datetime="${esc(review.createdAt)}">${date(review.createdAt)}</time></div>${review.title ? `<h3>${esc(review.title)}</h3>` : ''}<p>${esc(review.body || '')}</p><footer><strong>${esc(author(review.authorName))}</strong>${review.verifiedPurchase ? '<em>COMPRA VERIFICADA</em>' : ''}</footer></div>`;
      return article;
    };

    async function load() {
      if (loading) return;
      loading = true;
      status.hidden = true;
      try {
        const response = await fetch(`${root.dataset.endpoint}?page=${page}&per_page=6&sort=media`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        total = data.pagination.total;
        if (!total) { root.hidden = true; return; }
        root.querySelector('[data-review-score]').textContent = Number(data.stats.averageRating).toFixed(1);
        root.querySelector('[data-review-stars]').textContent = stars(Math.round(data.stats.averageRating));
        root.querySelector('[data-review-count]').textContent = `${total} RESEÑAS VERIFICADAS`;
        data.reviews.forEach((review) => grid.appendChild(card(review)));
        startAutoplay();
      } catch (error) {
        status.textContent = 'NO FUE POSIBLE CARGAR LAS RESEÑAS.';
        status.hidden = false;
      } finally {
        loading = false;
      }
    }

    const loadNext = async () => {
      if (loading || !total || grid.children.length >= total) return;
      page += 1;
      await load();
    };

    const stopAutoplay = () => window.clearInterval(autoplay);
    const advance = async () => {
      grid.querySelectorAll('.is-revealed').forEach((card) => {
        card.classList.remove('is-revealed');
        card.setAttribute('aria-expanded', 'false');
      });
      const cards = [...grid.children];
      if (cards.length < 2) return;
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      const atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - step / 2;
      if (atEnd && grid.children.length < total) await loadNext();
      const reachedLastReview = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - step / 2;
      grid.scrollTo({ left: reachedLastReview ? 0 : grid.scrollLeft + step, behavior: 'smooth' });
    };
    const startAutoplay = () => {
      stopAutoplay();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || grid.children.length < 2) return;
      autoplay = window.setInterval(advance, 4000);
    };

    grid.addEventListener('focusin', stopAutoplay);
    grid.addEventListener('focusout', startAutoplay);
    grid.addEventListener('touchstart', stopAutoplay, { passive: true });
    const toggleReview = (card) => {
      const reveal = !card.classList.contains('is-revealed');
      grid.querySelectorAll('.is-revealed').forEach((item) => {
        item.classList.remove('is-revealed');
        item.setAttribute('aria-expanded', 'false');
      });
      card.classList.toggle('is-revealed', reveal);
      card.setAttribute('aria-expanded', String(reveal));
      card.setAttribute('aria-label', reveal ? 'Ocultar texto de la reseña' : 'Ver texto de la reseña');
      stopAutoplay();
    };
    grid.addEventListener('click', (event) => {
      if (!window.matchMedia('(hover: none)').matches) return;
      const card = event.target.closest('.ul-product-reviews__card.has-media');
      if (card) toggleReview(card);
    });
    grid.addEventListener('keydown', (event) => {
      const card = event.target.closest('.ul-product-reviews__card.has-media');
      if (!card || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      toggleReview(card);
    });
    grid.addEventListener('scroll', () => {
      const cards = [...grid.children];
      if (cards.length < 2) return;
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - step * 2) loadNext();
    }, { passive: true });

    load();
  });
})();
